import { render } from "./ContextMenuBar.vue?vue&type=template&id=4f280735"
import script from "./ContextMenuBar.vue?vue&type=script&lang=js"
export * from "./ContextMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__